import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "grey lighten-5 px-4 py-4" };
const _hoisted_2 = { class: "require-field-wrapper pb-4" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DialogHeader = _resolveComponent("DialogHeader");
    const _component_v_card_title = _resolveComponent("v-card-title");
    const _component_v_divider = _resolveComponent("v-divider");
    const _component_DialogFooter = _resolveComponent("DialogFooter");
    const _component_v_card = _resolveComponent("v-card");
    const _component_v_dialog = _resolveComponent("v-dialog");
    return (_openBlock(), _createBlock(_component_v_dialog, {
        modelValue: _ctx.dialog,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.dialog) = $event)),
        "content-class": "responsive-dialog",
        persistent: "",
        "onClick:outside": _ctx.onClickCancel,
        onKeydown: _withKeys(_ctx.onClickCancel, ["esc"])
    }, {
        default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                    _createVNode(_component_DialogHeader, {
                        title: _ctx.$t(`${_ctx.lc}confirm_request_remittance_baromoney`),
                        "on-cancel": _ctx.onClickCancel
                    }, null, 8 /* PROPS */, ["title", "on-cancel"]),
                    _createVNode(_component_v_card, {
                        flat: "",
                        tile: "",
                        class: "grey lighten-4"
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                                _createElementVNode("div", _hoisted_2, [
                                    _createCommentVNode(" 변경 후 "),
                                    _createVNode(_component_v_card_title, { class: "text-body-1 pb-0" }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.lc}request_remittance_baromoney_message`, { receiver: _ctx.receiver,
                                                baromoney: _ctx.baromoney })), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ])
                            ]),
                            _createVNode(_component_v_divider),
                            _createVNode(_component_DialogFooter, {
                                cancel: true,
                                ok: true,
                                "on-cancel": _ctx.onClickCancel,
                                "on-ok": _ctx.onClickOk
                            }, null, 8 /* PROPS */, ["on-cancel", "on-ok"])
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 1 /* STABLE */
            })
        ]),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue", "onClick:outside", "onKeydown"]));
}
